/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * The main TodoMVC app module.
 *
 * @type {angular.Module}
 */
module tabs {
  'use strict';

  var tabsmodule = angular.module('TabsModule', ['navigation'])
    //.value('tabsData',  
    //  [
    //    { link: 'beverages', label: 'Getränke & Lebensmittel', template: 'tab-beverages.tpl.html' },
    //    { link: 'industries', label: 'Industrien', template: 'tab-industries.tpl.html' },
    //    { link: 'water', label: 'Wasser', template: 'tab-water.tpl.html' },
    //    { link: 'traffic', label: 'Verkehr & Umwelt', template: 'tab-traffic.tpl.html' }
    //  ]
    //)
    //.config(TabsConfig)
    //.controller('TabCtrl', TabCtrl)
    .directive('tabPage', tabPage)
    .directive('tabTitle', tabTitle)
    .directive('tabs', tabs);
}